<div class="component-box" *ngIf="isSearchVisible">
  <form (ngSubmit)="onSearch()" class="search-form">
    <div class="search-fields">
      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="searchForm.name" name="name" placeholder="Search by name">
      </mat-form-field>

      <app-searchable-select
        *ngIf="countries"
        [label]="'Country'"
        [placeholder]="'Select a country'"
        [selectFormControl]="countryControl"
        [options]="countryOptions">
      </app-searchable-select>

      <mat-checkbox *ngIf="showExactMatch" [(ngModel)]="searchForm.exactMatch" name="exactMatch">
        Exact match
      </mat-checkbox>
    </div>

    <div class="search-actions">
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
